export default __webpack_public_path__ + "static/media/aa.e627119f.png";